<div class="overflow-auto flex-1 p-16 gap-16">
  <div class="spinner-container flex-center" *ngIf="!dataLoaded; else contentLoaded">
    <mat-spinner diameter="16" mode="indeterminate"></mat-spinner>
  </div>

  <ng-template #contentLoaded>
    <ng-container *ngFor="let drawingConfiguration of drawingConfigurations; let i = index">
      <div *ngIf="canShowDrawingConfiguration(drawingConfiguration)" class="grouped-design-thumbnails-detail-card-container">
        <div class="grouped-design-thumbnails-detail-card-hover-container">
          <div class="grouped-design-thumbnails-detail-card-preview">
            <app-drawing-library-image-preview [drawingImage]="drawingConfiguration.drawing.image" shouldDownloadImage="false"></app-drawing-library-image-preview>
          </div>
          <div
            class="grouped-design-thumbnails-detail-card-form flex-column gap-16 p-16"
            [formGroup]="drawingConfigurationsFormArray.at(i)"
            [ngClass]="{
              'form-visible': isFormVisible[i]
            }"
          >
            <div class="flex gap-8">
              <mat-form-field>
                <input matInput type="number" formControlName="quantity" (focus)="selectInputContent($event); onFocusInput(i)" (blur)="onBlurInput(i)" />
              </mat-form-field>
              <p class="multiplier">x</p>
              <mat-form-field>
                <input matInput type="number" formControlName="rollLengthInMeter" (focus)="selectInputContent($event); onFocusInput(i)" (blur)="onBlurInput(i)" />
                <span matSuffix>
                  {{ 'GENERAL.UNIT.METER' | bmsTranslate }}
                </span>
              </mat-form-field>
            </div>
            <button
              mat-flat-button
              class="add-button"
              (click)="addDrawingToProductionSchedulePath(drawingConfiguration, drawingConfigurationsFormArray.at(i))"
              [disabled]="drawingConfigurationsFormArray.at(i).invalid"
            >
              <ng-container>
                <mat-icon svgIcon="add-small"></mat-icon>
                {{ 'GENERAL.ACTIONS.ADD' | bmsTranslate }}
              </ng-container>
            </button>
          </div>
        </div>
        <div class="grouped-design-thumbnails-detail-card-footer flex-column flex-center gap-6">
          <p class="no-margin">{{ drawingConfiguration.drawing.name }}</p>
          <span>
            {{ drawingConfiguration.drawing.dimensionsInPixels?.widthInPx ?? 0 }} x {{ drawingConfiguration.drawing.dimensionsInPixels?.heightInPx ?? 0 }}
            <ng-container *ngIf="canShowModifiedDate(drawingConfiguration)"> - {{ drawingConfiguration.drawing.dateModified | DateTime: 'DATE_SHORT' }} </ng-container>
          </span>
        </div>
      </div>
    </ng-container>
  </ng-template>
</div>
